import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';

@Component({
  selector: 'app-phrappointmentdetails',
  templateUrl: './phrappointmentdetails.component.html',
  styleUrls: ['./phrappointmentdetails.component.scss'],
  providers: [AppService, IceNavService]
})
export class PhrappointmentdetailsComponent implements OnInit {

  constructor(private appSvc: AppService, private loginSvc: LoginService, private navSvc: IceNavService) {
    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Appointment Details", {}, true, "");
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }
}
